import { IAction } from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  vatReturnDetail: any;
  countries: any;
  countriesFEst: any;
  fixedEstablishments: any;
  quarters: any;
  monthQuarterList: any;
  correctionsCountries: any;
}

const initialState: IState = {
  vatReturnDetail: {
    status: null,
    data: null,
    suppliesFromMemberStateOfIdentification: null,
    suppliesFromFixedEstablishments: null,
    vatCorrections: null,
    temporarySaveStatus: null,
    submitNilStatus: null,
    finalSubmitStatus: null,
    mscon: null,
  },
  countries: {
    data: null,
    status: null,
  },
  countriesFEst: {
    data: null,
    status: null,
  },
  fixedEstablishments: {
    data: null,
    status: null,
  },
  quarters: {
    data: null,
    status: null,
  },
  monthQuarterList: {
    status: null,
    data: null,
  },
  correctionsCountries: {
    data: null,
    status: null,
  },
};

const VatReturnDetailReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_VATRETURN_DETAIL:
      return {
        ...state,
        vatReturnDetail: {
          ...state.vatReturnDetail,
          status: action.status,
          data: action.data.data,
          suppliesFromMemberStateOfIdentification:
            action.data.supplies_from_member_state_of_identification,
          suppliesFromFixedEstablishments:
            action.data.supplies_from_fixed_establishments,
          vatCorrections: action.data.vat_corrections,
          mscon: action.data.mscon,
        },
      };
    case Types.SET_COUNTRIES_WITH_VAT_RATE:
      return {
        ...state,
        countries: {
          data: action.data,
          status: action.status,
        },
      };
    case Types.SET_COUNTRIES_WITH_VAT_RATE_FEST:
      return {
        ...state,
        countriesFEst: {
          data: action.data,
          status: action.status,
        },
      };
    case Types.SET_SUPPLIES_FROM_MEMBER_STATE_OF_IDENTIFICATION:
      return {
        ...state,
        vatReturnDetail: {
          ...state.vatReturnDetail,
          suppliesFromMemberStateOfIdentification: action.data,
        },
      };
    case Types.SET_SUPPLIES_FROM_FIXED_ESTABLISHMENTS:
      return {
        ...state,
        vatReturnDetail: {
          ...state.vatReturnDetail,
          suppliesFromFixedEstablishments: action.data,
        },
      };
    case Types.SET_MSCON:
      return {
        ...state,
        vatReturnDetail: {
          ...state.vatReturnDetail,
          mscon: action.data,
        },
      };
    case Types.SET_FIXED_ESTABLISHMENTS_OF_VAT_RETURN:
      return {
        ...state,
        fixedEstablishments: {
          data: action.data,
          status: action.status,
        },
      };
    case Types.TEMPORARY_SAVE_VAT_RETURN:
      return {
        ...state,
        vatReturnDetail: {
          ...state.vatReturnDetail,
          temporarySaveStatus: action.status,
        },
      };
    case Types.FINAL_SAVE_VAT_RETURN:
      return {
        ...state,
        vatReturnDetail: {
          ...state.vatReturnDetail,
          finalSubmitStatus: action.status,
        },
      };
    case Types.SUBMIT_NIL_VAT_RETURN:
      return {
        ...state,
        vatReturnDetail: {
          ...state.vatReturnDetail,
          submitNilStatus: action.status,
        },
      };
    case Types.SET_QUARTERS:
      return {
        ...state,
        quarters: {
          data: action.data,
          status: action.status,
        },
      };
    case Types.SET_MONTH_QUARTERS:
      return {
        ...state,
        monthQuarterList: {
          ...state.monthQuarterList,
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_VAT_CORRECTIONS:
      return {
        ...state,
        vatReturnDetail: {
          ...state.vatReturnDetail,
          vatCorrections: action.data,
        },
      };
    case Types.SET_CORRECTIONS_COUNTRIES:
      return {
        ...state,
        correctionsCountries: {
          data: action.data,
          status: action.status,
        },
      };
    case Types.RESET_REDUCER:
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};

export default VatReturnDetailReducer;
